/*
 *  Cart Drawer
 *    Provides scripts for the cart drawer.
 *
 *  Version:
 *    1.0.0 - 2023/07/11
 */

import $ from 'jquery';

import { ON_CART_FINISHED } from '@process-creative/slate-theme-tools';

import { Cart } from './Cart';
import { CLASS_OPEN, CLASS_SCROLL_DISABLED } from '../../tools/constants/classes';

//Selectors
const CART_DRAWER_CONTAINER = '[data-cart-drawer-container]';
const CART_SELECTOR = '[data-cart-selector]'
const CART_INNER_SELECTOR = '[data-inner-cart-selector]'
const CART_OPEN_SELECTOR = '[data-cart-drawer-toggle]'
const CART_CLOSE_SELECTOR = '[data-cart-drawer-close]'

//Classes
const CLASS_HAS_FROZEN_SCROLL = 'has-frozen-scroll'
const CLASS_CART_DRAWER_OPEN = 'is-drawer-open';
const CLASS_IS_HIDDEN = 'is-hidden';

export class CartDrawer extends Cart {
  constructor(container) {
    super(container);
    this.container = container;
    this.isCustomProductPage = !!$('customiser-engine').length;
    this.cartElem = container.find(CART_SELECTOR);
    window.openDrawer = this.openDrawer.bind(this);

    //Events
    $(document).on(ON_CART_FINISHED, () => {
      super.onCartFinished()
      // Hacking in some stuff. We only want to auto open the cart drawer if the cusotmiser is not open
      const customiserIsOpen = document.querySelector('customiser-engine')?.classList.contains('is-open')
      if(!customiserIsOpen){
        this.openDrawer();
      }
    });

    this.container.on('click touchend', ({ target }) => {
      const targetIsCartBG = target == this.cartElem[0]

      if (targetIsCartBG && $(CART_SELECTOR).hasClass(CLASS_CART_DRAWER_OPEN)) {
        this.closeDrawer();
      }
    })

    $(document).on('click', CART_OPEN_SELECTOR, e => this.onDrawerTrigger(e));
    $(document).on('click', CART_CLOSE_SELECTOR, e => this.closeDrawer(e));
  }

  onDrawerTrigger(e) {
    e.preventDefault();
    this.openDrawer();
  }

  openDrawer() {
    this.container.removeClass(CLASS_IS_HIDDEN)
    $('body').addClass(CLASS_HAS_FROZEN_SCROLL)
    setTimeout(() => {
      this.cartElem.addClass(CLASS_CART_DRAWER_OPEN)
    }, 200)
  }

  closeDrawer() {
    this.cartElem.removeClass(CLASS_CART_DRAWER_OPEN);
    document.body.classList.remove(CLASS_SCROLL_DISABLED);


    setTimeout(() => {
      this.container.addClass(CLASS_IS_HIDDEN);
      $('body').removeClass(CLASS_HAS_FROZEN_SCROLL);
    }, 500);
  }
}
$(() => $(CART_DRAWER_CONTAINER).each((i,e) => new CartDrawer($(e))))